// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   DonateImpact — cream pillar grid + dark mountain stat strip
   ============================================================ */

.dni {
  display: flex;
  flex-direction: column;
}

/* ── TOP — cream ── */
.dni__top {
  background: var(--c-cream);
  padding-block: clamp(3rem, 6vw, 5rem);
  border-top: 1px solid var(--line);
}

/* Centred eyebrow with horizontal rust rules */
.dni__eyebrow-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(1rem, 2.5vw, 2.5rem);
  margin-bottom: clamp(2.5rem, 5vw, 4.5rem);
}

.dni__eyebrow-rule {
  display: block;
  flex: 1 1;
  max-width: clamp(4rem, 10vw, 9rem);
  height: 1px;
  background: var(--accent);
  opacity: 0.55;
}

.dni__eyebrow {
  color: var(--accent) !important;
  letter-spacing: 0.24em;
  white-space: nowrap;
  flex-shrink: 0;
  font-size: var(--fs-lead);
  margin: 0;
}

/* Pillar grid — 4 equal cols */
.dni__pillars {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
}

.dni__pillar {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  padding: clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2.5rem) clamp(1.5rem, 2vw, 2rem);
  position: relative;
}

/* Vertical dividers between pillars */
.dni__pillar:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 8%;
  bottom: 8%;
  width: 1px;
  background: var(--line);
}

/* Icon container — large, shows the illustrated SVG well */

/* Label */
.dni__pillar-label {
  font-family: var(--font-body);
  font-size: var(--fs-body);
  font-weight: 900;

  text-transform: uppercase;
  color: var(--c-ink);
  margin: 0;
  line-height: 1;
}
.dni__pillar-label--rust {
  color: var(--accent);
}

/* Description */
.dni__pillar-desc {
  font-family: var(--font-body);
  font-size: clamp(0.8rem, 1vw, 0.9rem);
  color: var(--text-muted);
  line-height: 1.62;
  margin: 0;
  max-width: 14rem;
}

/* ── DARK MOUNTAIN STRIP ── */
.dni__strip {
  position: relative;
  background: #161e14;
  overflow: hidden;
  min-height: clamp(140px, 24vw, 240px);
  display: flex;
  align-items: center;
}

.dni__strip-bg {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}
.dni__strip-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom;
  opacity: 0.45;
  filter: brightness(0.35) saturate(0.5);
}

.dni__strip-inner {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  padding-block: clamp(2rem, 4vw, 3.5rem);
  width: 100%;
}

.dni__stat {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-inline: clamp(1rem, 2.5vw, 2.5rem);
  position: relative;
}

.dni__stat:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 5%;
  bottom: 5%;
  width: 1px;
  background: rgba(255, 255, 255, 0.08);
}

/* Big Playfair number */
.dni__stat-num {
  font-family: var(--font-serif);
  font-size: clamp(2.5rem, 6vw, 5rem);
  font-weight: 400;
  color: rgba(220, 204, 180, 0.6);
  line-height: 1;
  letter-spacing: -0.01em;
}
.dni__stat-num--rust {
  color: var(--accent);
}

.dni__stat-label {
  font-family: var(--font-body);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.38);
}

.dni__stat-rule {
  display: block;
  width: clamp(1.5rem, 2.5vw, 2.5rem);
  height: 2px;
  background: rgba(220, 204, 180, 0.18);
  margin-top: 0.15rem;
}
.dni__stat-rule--rust {
  background: var(--accent);
  opacity: 0.6;
}

/* Responsive */
@media (max-width: 767.98px) {
  .dni__pillars {
    grid-template-columns: repeat(2, 1fr);
  }
  .dni__pillar:nth-child(2)::after {
    display: none;
  }
  .dni__strip-inner {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 1.5rem;
  }
  .dni__stat:nth-child(2)::after {
    display: none;
  }
}
@media (max-width: 479.98px) {
  .dni__pillars {
    grid-template-columns: 1fr;
  }
  .dni__pillar::after {
    display: none;
  }
  .dni__strip-inner {
    grid-template-columns: 1fr;
  }
  .dni__stat::after {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DonateImpact.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,SAAO;EACP,kCAAkC;EAClC,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,qFAAqF;EACrF,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,UAAU;EACV,UAAU;EACV,uBAAuB;AACzB;;AAEA,2DAA2D;;AAE3D,UAAU;AACV;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;;EAEhB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,UAAU;EACV,UAAU;EACV,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,WAAW;EACX,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;IACE,qCAAqC;IACrC,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================================\n   DonateImpact — cream pillar grid + dark mountain stat strip\n   ============================================================ */\n\n.dni {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── TOP — cream ── */\n.dni__top {\n  background: var(--c-cream);\n  padding-block: clamp(3rem, 6vw, 5rem);\n  border-top: 1px solid var(--line);\n}\n\n/* Centred eyebrow with horizontal rust rules */\n.dni__eyebrow-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(1rem, 2.5vw, 2.5rem);\n  margin-bottom: clamp(2.5rem, 5vw, 4.5rem);\n}\n\n.dni__eyebrow-rule {\n  display: block;\n  flex: 1;\n  max-width: clamp(4rem, 10vw, 9rem);\n  height: 1px;\n  background: var(--accent);\n  opacity: 0.55;\n}\n\n.dni__eyebrow {\n  color: var(--accent) !important;\n  letter-spacing: 0.24em;\n  white-space: nowrap;\n  flex-shrink: 0;\n  font-size: var(--fs-lead);\n  margin: 0;\n}\n\n/* Pillar grid — 4 equal cols */\n.dni__pillars {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0;\n}\n\n.dni__pillar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 1rem;\n  padding: clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2.5rem) clamp(1.5rem, 2vw, 2rem);\n  position: relative;\n}\n\n/* Vertical dividers between pillars */\n.dni__pillar:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 8%;\n  bottom: 8%;\n  width: 1px;\n  background: var(--line);\n}\n\n/* Icon container — large, shows the illustrated SVG well */\n\n/* Label */\n.dni__pillar-label {\n  font-family: var(--font-body);\n  font-size: var(--fs-body);\n  font-weight: 900;\n\n  text-transform: uppercase;\n  color: var(--c-ink);\n  margin: 0;\n  line-height: 1;\n}\n.dni__pillar-label--rust {\n  color: var(--accent);\n}\n\n/* Description */\n.dni__pillar-desc {\n  font-family: var(--font-body);\n  font-size: clamp(0.8rem, 1vw, 0.9rem);\n  color: var(--text-muted);\n  line-height: 1.62;\n  margin: 0;\n  max-width: 14rem;\n}\n\n/* ── DARK MOUNTAIN STRIP ── */\n.dni__strip {\n  position: relative;\n  background: #161e14;\n  overflow: hidden;\n  min-height: clamp(140px, 24vw, 240px);\n  display: flex;\n  align-items: center;\n}\n\n.dni__strip-bg {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: flex-end;\n  overflow: hidden;\n}\n.dni__strip-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center bottom;\n  opacity: 0.45;\n  filter: brightness(0.35) saturate(0.5);\n}\n\n.dni__strip-inner {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0;\n  padding-block: clamp(2rem, 4vw, 3.5rem);\n  width: 100%;\n}\n\n.dni__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding-inline: clamp(1rem, 2.5vw, 2.5rem);\n  position: relative;\n}\n\n.dni__stat:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 5%;\n  bottom: 5%;\n  width: 1px;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* Big Playfair number */\n.dni__stat-num {\n  font-family: var(--font-serif);\n  font-size: clamp(2.5rem, 6vw, 5rem);\n  font-weight: 400;\n  color: rgba(220, 204, 180, 0.6);\n  line-height: 1;\n  letter-spacing: -0.01em;\n}\n.dni__stat-num--rust {\n  color: var(--accent);\n}\n\n.dni__stat-label {\n  font-family: var(--font-body);\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.38);\n}\n\n.dni__stat-rule {\n  display: block;\n  width: clamp(1.5rem, 2.5vw, 2.5rem);\n  height: 2px;\n  background: rgba(220, 204, 180, 0.18);\n  margin-top: 0.15rem;\n}\n.dni__stat-rule--rust {\n  background: var(--accent);\n  opacity: 0.6;\n}\n\n/* Responsive */\n@media (max-width: 767.98px) {\n  .dni__pillars {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .dni__pillar:nth-child(2)::after {\n    display: none;\n  }\n  .dni__strip-inner {\n    grid-template-columns: repeat(2, 1fr);\n    row-gap: 1.5rem;\n  }\n  .dni__stat:nth-child(2)::after {\n    display: none;\n  }\n}\n@media (max-width: 479.98px) {\n  .dni__pillars {\n    grid-template-columns: 1fr;\n  }\n  .dni__pillar::after {\n    display: none;\n  }\n  .dni__strip-inner {\n    grid-template-columns: 1fr;\n  }\n  .dni__stat::after {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
